module.exports = __webpack_public_path__ + "img/card-3.70374038.png";